import { ReduxAction } from '../../enums/const-enums';

const initialState: AppModel.ChallengeData = {
  objectType: null,
  altFlowType: null,
  challenges: null,
  challenge_id: null,
  encrypted: null,
  json_extra: null,
  helpdesk_ref: null,
  phone_number: null,
  qr_id: null,
  submit_url: null,
  token_info: null,
  validity: null,
  uri: null,
};

export interface ChallengeAction {
  type: ReduxAction;
  payload: AppModel.ChallengeData;
}

export function challengeReducer(
  state: AppModel.ChallengeData = initialState,
  action: ChallengeAction,
): AppModel.ChallengeData {
  switch (action.type) {
    case ReduxAction.CHALLENGE_DATA_UPDATE:
      state = action.payload;
      state.helpdesk_ref = action.payload.helpdesk_ref || null;
      break;
    case ReduxAction.CHALLENGE_DATA_CLEAR:
      state = initialState;
      break;
  }
  return state;
}
